<template>
  <section class="client organization header">
    <v-parallax
      :src="organization.coverImage"
      :height="$vuetify.breakpoint.mdAndUp ? 400 : 300"
    >
      <v-layout column justify-space-between fill-height>
        <div></div>
        <div class="text-xs-center logo">
          <v-avatar :size="$vuetify.breakpoint.smAndDown ? 70 : 128" color="transparent" @click="$refs.logoInput.click()">
            <img :src="preview || organization.logo" />
            <div class="upload"><v-icon>mdi-cloud-upload</v-icon></div>
          </v-avatar>
          <input type="file" name="file" ref="logoInput" @change="setLogo" style="display: none;" />
        </div>

        <div class="text-xs-center">
          <v-dialog v-model="editing" max-width="600px" v-if="edit">
            <v-btn color="secondary darken-2" slot="activator">
              <v-icon left>mdi-pencil</v-icon> Edit
            </v-btn>
            <v-card>
              <v-card-title class="title">
                Edit Header
                <v-spacer />
                <v-btn icon @click="cancel"  >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-form v-model="valid" @submit.prevent="submit">
                  <v-text-field
                    label="Name"
                    v-model="header.name"
                    required :rules="rules.name"
                    :error-messages="errors.name || []"
                  />
                </v-form>
              </v-card-text>
              <v-card-actions><v-spacer />
                <v-btn flat @click="cancel">
                  Cancel
                </v-btn>
                <v-btn :color="valid ? 'success' : 'error'" :disabled="!valid" @click="submit">
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <div :class="$vuetify.breakpoint.lgAndUp ? 'display-1' : 'title'" class="black--text">
            {{ organization.name }}
          </div>
        </div>
      </v-layout>
    </v-parallax>
  </section>
</template>

<script>
// Vue Component
export default {
  props: {
    organization: Object,
    edit: Boolean,
  },
  data() {
    return {
      editing: false,
      valid: true,
      rules: {
        name: [v => !!v || 'must be specified'],
      },
      errors: {},
      modified: { ...this.organization },
      header: (({ name }) => ({ name }))(this.organization),
      logo: null,
      preview: null,
    }
  },
  methods: {
    cancel() {
      this.header = (({ name }) => ({ name }))(this.organization)
      this.editing = false
      this.errors = {}
    },
    submit() {
      if (this.valid) {
        this.modified = { ...this.organization, ...this.header }
        this.update()
      }
    },
    update() {
      this.$store.dispatch('client/organization/update', this.modified).then(errors => {
        if (errors) {
          this.errors = errors
          this.$store.dispatch('snackbarError', 'There was a problem saving the header')
        } else {
          this.$store.dispatch('snackbarSuccess', 'The header was saved successfully')
          this.editing = false
        }
      })
    },
    setLogo() {
      this.logo = this.$refs.logoInput.files[0]
      const reader = new FileReader()
      reader.addEventListener('load', () => (this.preview = reader.result), false)
      if (this.logo) reader.readAsDataURL(this.logo)
      if (this.logo) {
        let logoData = new FormData()
        logoData.append('logo', this.logo)
        this.$http
          .post('/client/organization/logo', logoData, { headers: { 'Content-Type': 'multipart/form-data' } })
          .then(() => this.$store.dispatch('snackbarSuccess', 'Logo Updated'))
          .catch(() => {
            this.preview = this.organization.logo
            this.$store.dispatch('snackbarError', 'Logo update Failed')
          })
      }
    },
  },
}
</script>

<style lang="scss">
.client.organization.header {
  .v-parallax__content {
    background-image: linear-gradient(to top,
      rgb(250, 250, 250) 0px,
      rgba(250, 250, 250, 10) 21px,
      rgba(250, 250, 250, 0) 86px
    )
  }
}

.logo:hover div img {
  opacity: 0.5;
}

.logo div.upload {
  display: none;
  position: absolute;
}

.logo:hover div.upload {
  display: block;
  cursor: pointer;
}
</style>
